export default __webpack_public_path__ + "static/media/kanban.0b827b69.svg";